module.exports = __webpack_public_path__ + "img/tile_three.2b608ac1.png";